import { styled, Popper } from '@mui/material';

export const PopperStyled = styled(Popper)`
  border: 1px solid #666;
  border-radius: 5px;
`;
